"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SelectMenu = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var styled_components_1 = require("styled-components");
var react_1 = require("react");
var IoIosArrowDown_1 = require("@react-icons/all-files/io/IoIosArrowDown");
var ClickAwayListener_1 = require("./ClickAwayListener");
var SelectMenu = function (props) {
    var _a = (0, react_1.useState)(false), open = _a[0], setOpen = _a[1];
    var selected = (0, react_1.useMemo)(function () {
        return props.items.find(function (it) { return it.value === props.selected; });
    }, [props.items, props.selected]);
    var onSelect = (0, react_1.useCallback)(function (item) {
        setOpen(false);
        props.onSelect(item);
    }, [props.onSelect]);
    return ((0, jsx_runtime_1.jsx)(ClickAwayListener_1.ClickAwayListener, __assign({ onClickAway: function () { return setOpen(false); } }, { children: (0, jsx_runtime_1.jsxs)(Container, __assign({ className: "twap-select-menu" }, { children: [(0, jsx_runtime_1.jsx)(StyledSelected, __assign({ onClick: function () { return setOpen(!open); }, className: "".concat(props.className, " twap-select-menu-button") }, { children: props.SelectedContent ? ((0, jsx_runtime_1.jsx)(props.SelectedContent, { item: selected })) : ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsxs)("p", { children: [" ", selected === null || selected === void 0 ? void 0 : selected.text] }), (0, jsx_runtime_1.jsx)(IoIosArrowDown_1.IoIosArrowDown, {})] })) })), open && ((0, jsx_runtime_1.jsx)(Menu, __assign({ className: "twap-select-menu-list" }, { children: props.items.map(function (item) { return ((0, jsx_runtime_1.jsx)(StyledMenuItem, __assign({ className: "twap-select-menu-list-item", onClick: function () { return onSelect(item); } }, { children: props.ItemContent ? (0, jsx_runtime_1.jsx)(props.ItemContent, { item: item }) : (0, jsx_runtime_1.jsx)("p", { children: item.text }) }), item.value)); }) })))] })) })));
};
exports.SelectMenu = SelectMenu;
var Container = styled_components_1.styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  position: relative;\n"], ["\n  position: relative;\n"])));
var StyledSelected = (0, styled_components_1.styled)("button")({
    display: "flex",
    alignItems: "center",
    gap: 5,
    padding: "0px",
    fontSize: 14,
    textTransform: "none",
    color: "inherit",
    cursor: "pointer",
    svg: {
        width: 14,
        height: 14,
    },
});
var Menu = styled_components_1.styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  position: absolute;\n  background-color: white;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);\n  z-index: 1000;\n  margin-top: 5px;\n  top: 100%;\n  overflow: hidden;\n  min-width: 100%;\n"], ["\n  position: absolute;\n  background-color: white;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);\n  z-index: 1000;\n  margin-top: 5px;\n  top: 100%;\n  overflow: hidden;\n  min-width: 100%;\n"])));
var StyledMenuItem = styled_components_1.styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  padding: 7px 15px 7px 10px;\n  cursor: pointer;\n  p {\n    margin: 0;\n  }\n"], ["\n  padding: 7px 15px 7px 10px;\n  cursor: pointer;\n  p {\n    margin: 0;\n  }\n"])));
var templateObject_1, templateObject_2, templateObject_3;
